import type { ReactNode } from 'react';
import styles from './CartLineItem.module.css';

export type CartLineItemProps = {
  label: ReactNode;
  price: ReactNode;
  className?: string;
};

export const CartLineItem = ({ label, price, className }: CartLineItemProps) => (
  <div className={className ? `${styles.row} ${className}` : styles.row}>
    <div className={styles.label}>{label}</div>
    <div className={styles.price}>{price}</div>
  </div>
);
